<template>
    <div class="common">
        <article class="paragraph" v-if="articleLists">
            <div class="control-height">
                <author :expertAuthor=expertAuthor v-if="expertAuthor"></author>
                <div class="expert-item" v-for="(article,index) in articleLists" :key="index">
                    <strong><span class="label">太平洋号</span><a :href="article.videoArticleFlag | articleUrl(article.articleId)" target="_blank" v-html="article.title" @click="countAd(4457)"></a></strong>
                    <a :href="article.videoArticleFlag | articleUrl(article.articleId)" class="docLink" target="_blank"  @click="countAd(4457)">
                        <div class="doc" v-html="article.content"></div>
                    </a>
                    <div class="paragraphInfo">
                        <span><i>分类：</i>太平洋号</span>
                        <span><i>作者：</i>{{article.authorName}}</span>
                        <span><i>时间：</i>{{article.createAt}}</span>
                    </div>
                </div>
            </div>
            <paging :totalPages=totalPages @reqData=reqHj></paging>
            <search-box :id="2"></search-box>
        </article>
        <error-acrticle v-else :id="4458"></error-acrticle>
    </div>
</template>

<script>
import Author from '../../global/Author.vue'
import ErrorAcrticle from '../../global/ErrorAcrticle.vue'
    export default {
  components: { Author, ErrorAcrticle },
        name: 'Common',
        data() {
            return {
                expertAuthor: null, // 太平洋号作者
                articleLists: [], //文章列
                totalPages: 0, //文章列表总页数
            }
        },
        filters: {
            //根据文章列的字段判断是video类型还是article类型
            articleUrl(flag,value) {
                if(flag === 0) {
                    return `//hj.pcauto.com.cn/article/${value}.html`
                }else{
                    return `//hj.pcauto.com.cn/video/${value}.html`
                }
            }
        },
        methods: {
             async reqHj(pageNo = 1) {
                 try {
                     const res = await this.fetHj({
                         q:this.$global.q,
                         pageNo
                     })
                    if(res) {
                        document.body.scrollTop = document.documentElement.scrollTop = 0
                    }                     
                     this.totalPages = res.totalPage
                     this.expertAuthor = res.expertAuthor
                     this.articleLists = res.result
                 } catch (error) {
                    console.error(error)
                 }
            }
        },
        mounted() {
            this.countColumnAd(10715)
            this.reqHj()
            this.$EventBus.$on(`${this.$global.tab.title}`,() => {this.reqHj()})
        }
    }
</script>

<style lang="scss" scoped>
.common {
    width: 620px;
    .paragraph {
        .expert-item {
            margin-top: 20px;
            strong {
                font-weight: normal;
                font-size: 16px;
                line-height: 32px;
                .label {
                    color: #eb484f;
                    border: 1px solid #eb484f;
                    padding: 2px 8px;
                    vertical-align: 2px;
                    *vertical-align: -1px;
                    font-size: 12px;
                    margin-right: 6px;
                    font-family: Microsoft Yahei;
                    border-radius: 2px;
                    line-height: 16px;
                    display: inline-block;
                }
                a {
                    text-decoration: underline;
                    color: #225599;
                    ::v-deep em {
                        color: #cc0000;
                        text-decoration: underline;
                        font-style: normal;
                    }
                }
            }
            .docLink {
                text-decoration: none;
                display: block;
                .doc {
                    color: #333333;
                    line-height: 22px;
                    overflow: hidden;
                    position: relative;
                    ::v-deep em {
                        color: #cc0000;
                        font-style: normal;
                    }
                }
            }
            .paragraphInfo {
                span {
                    width: 120px;
                    display: inline-block;
                    color: #333333;
                    height: 20px;
                    overflow: hidden;
                    word-break: break-all;
                    word-wrap: break-word;
                    margin-right: 5px;
                    i {
                        color: #777777;
                        font-style: normal;
                    }
                }
            }
        }
    }
}
</style>